import Fileupload from './Fileupload';

export default Fileupload;
